/**
 * Aiuti della paginazione degli elenchi lunghi: quante pagine, quale pagina
 * vale davvero e quali numeri mostrare nella barra.
 */

/** Righe per pagina degli elenchi paginati, se la vista non ne chiede altre. */
export const PER_PAGINA = 10;

export const numeroPagine = (righe: number, perPagina = PER_PAGINA): number =>
  Math.max(1, Math.ceil(righe / perPagina));

/**
 * La pagina letta dall'URL, ricondotta tra la prima e l'ultima: un numero
 * rimasto da un filtro piu largo non lascia l'elenco vuoto.
 */
export function paginaValida(valore: string | null, pagine: number): number {
  const n = Number(valore);
  if (!Number.isInteger(n) || n < 1) return 1;
  return Math.min(n, pagine);
}

export const righeDellaPagina = <T>(
  elenco: readonly T[],
  pagina: number,
  perPagina = PER_PAGINA,
): T[] => elenco.slice((pagina - 1) * perPagina, pagina * perPagina);

/**
 * I numeri della barra: sempre la prima, l'ultima e le vicine della
 * corrente, con i puntini dove se ne saltano almeno due. Un solo numero
 * saltato si mostra, perche i puntini occuperebbero lo stesso posto.
 */
export function vociPaginazione(corrente: number, pagine: number): (number | 'puntini')[] {
  const visibili = new Set([1, pagine, corrente - 1, corrente, corrente + 1]);
  const voci: (number | 'puntini')[] = [];
  let prima = 0;
  for (let p = 1; p <= pagine; p++) {
    if (!visibili.has(p)) continue;
    if (p - prima === 2) voci.push(p - 1);
    else if (p - prima > 2) voci.push('puntini');
    voci.push(p);
    prima = p;
  }
  return voci;
}
